(function () {
  'use strict';

  /* @ngdoc object
   * @name postponements.editPostponement
   * @description
   *
   */
  angular
    .module('neo.home.postponements.edit', [
      'ui.router'
    ]);
}());
